/**
 * Facebook Pixel Tracking Utility for NEUROLEX
 * Pixel ID: 3858148811154854
 * 
 * Events tracked:
 * - PageView (automatic)
 * - CompleteRegistration (sign up)
 * - Subscribe (subscription purchase)
 * - Purchase (payment completion - Stripe/CinetPay)
 * - Lead (referral signup)
 */

// Check if fbq is available
const fbq = (...args) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq(...args);
  }
};

// Track page view
export const trackPageView = () => {
  fbq('track', 'PageView');
};

// Track new user registration/sign up
export const trackSignUp = (userData = {}) => {
  fbq('track', 'CompleteRegistration', {
    content_name: 'NEUROLEX Account',
    status: 'complete',
    currency: 'USD',
    value: 0,
    ...userData
  });
};

// Track subscription start (trial or paid)
export const trackSubscribe = (subscriptionData = {}) => {
  fbq('track', 'Subscribe', {
    content_name: subscriptionData.plan || 'Premium',
    currency: subscriptionData.currency || 'USD',
    value: subscriptionData.value || 0,
    predicted_ltv: subscriptionData.predicted_ltv || 0,
    ...subscriptionData
  });
};

// Track purchase completion (Stripe or CinetPay)
export const trackPurchase = (purchaseData = {}) => {
  fbq('track', 'Purchase', {
    content_name: purchaseData.plan || 'Premium Subscription',
    content_type: 'subscription',
    currency: purchaseData.currency || 'USD',
    value: purchaseData.value || 0,
    content_ids: [purchaseData.plan_id || 'premium'],
    num_items: 1,
    ...purchaseData
  });
};

// Track CinetPay mobile money payment specifically
export const trackCinetPayPurchase = (paymentData = {}) => {
  fbq('track', 'Purchase', {
    content_name: 'NEUROLEX Premium (CinetPay)',
    content_type: 'subscription',
    currency: paymentData.currency || 'XAF',
    value: paymentData.value || 0,
    payment_method: 'mobile_money',
    country: paymentData.country || 'CM',
    ...paymentData
  });
};

// Track referral lead (when someone clicks referral link)
export const trackReferralLead = (referralCode) => {
  fbq('track', 'Lead', {
    content_name: 'Referral Signup',
    content_category: 'referral',
    referral_code: referralCode
  });
};

// Track initiate checkout (when user starts payment flow)
export const trackInitiateCheckout = (checkoutData = {}) => {
  fbq('track', 'InitiateCheckout', {
    content_name: checkoutData.plan || 'Premium',
    currency: checkoutData.currency || 'USD',
    value: checkoutData.value || 0,
    num_items: 1,
    ...checkoutData
  });
};

// Track add payment info (when user enters payment details)
export const trackAddPaymentInfo = (paymentData = {}) => {
  fbq('track', 'AddPaymentInfo', {
    content_name: paymentData.plan || 'Premium',
    currency: paymentData.currency || 'USD',
    value: paymentData.value || 0,
    ...paymentData
  });
};

// Custom event for lesson completion
export const trackLessonComplete = (lessonData = {}) => {
  fbq('trackCustom', 'LessonComplete', {
    content_name: lessonData.concept || 'Daily Lesson',
    score: lessonData.score || 0,
    streak: lessonData.streak || 0,
    ...lessonData
  });
};

export default {
  trackPageView,
  trackSignUp,
  trackSubscribe,
  trackPurchase,
  trackCinetPayPurchase,
  trackReferralLead,
  trackInitiateCheckout,
  trackAddPaymentInfo,
  trackLessonComplete
};
